import {useEffect} from 'react';
import {getTeamCredits} from '@Components/team-credits/team-credits-library';
import {useAppSelector} from '@/hooks';

export function useGetTeamCredits(): number | null {
  const teamCredits = useAppSelector((state) => {
    return state.teamCredits.credits;
  });

  useEffect((): void => {
    if (teamCredits !== null) {
      return;
    }

    void getTeamCredits();
  }, []);

  return teamCredits;
}
